import styled, { css } from 'styled-components';

import * as tokens from '@mewssystems/design-tokens';

interface StoryContainerProps {
    contrast?: boolean;
    currentTheme?: keyof typeof tokens;
}

export const StoryContainer = styled.div<StoryContainerProps>`
    padding: ${tokens.light.SPACING_200}px;
    min-width: ${tokens.light.SPACING_1200}px;
    text-align: center;

    ${({ contrast, currentTheme }) =>
        contrast &&
        currentTheme &&
        css`
            background-color: ${tokens[currentTheme].BACKGROUND_STATIC_INVERSE};
        `}
`;
